const toDate = (dateStr) => {
    var parts = dateStr.split("-")
    return new Date(parts[2], parts[0]-1, parts[1])
}

export default toDate; 